import { render } from "./BlogSearch.vue?vue&type=template&id=cc8dfe98"
import script from "./BlogSearch.vue?vue&type=script&lang=js"
export * from "./BlogSearch.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__